/**
 * Historie van één verlofaanvraag (Epic 2 — Verlof correctie, Story 2.10,
 * FR-16).
 *
 * Naar het model van `useMijnVerlof.ts`, met één verschil: de historie wordt
 * pas opgehaald wanneer iemand de regel daadwerkelijk uitklapt (`enabled`).
 * Een verlofoverzicht met twintig regels zou anders twintig aanroepen doen
 * voor gegevens die niemand opvraagt.
 *
 * De sleutel hangt onder `leaveKeys.all`, zodat een correctie die de
 * verlofregels ongeldig maakt ook de uitgeklapte historie meeneemt.
 */

import { useQuery } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';
import { leaveKeys } from './useMijnVerlof';

export const leaveHistoryKey = (requestId: number) =>
  [...leaveKeys.all, 'history', requestId] as const;

export function useLeaveHistory(requestId: number | null, enabled = true) {
  return useQuery({
    queryKey: leaveHistoryKey(requestId ?? 0),
    queryFn: () => verlofApi.getLeaveHistory(requestId!),
    // Vaste feiten uit het verleden -- alleen de laatste regel kan nog
    // veranderen (een doorzetting die opnieuw geprobeerd wordt), dus dezelfde
    // korte cache als het overzicht zelf is ruim genoeg.
    staleTime: 1000 * 60,
    enabled: enabled && requestId != null,
  });
}
